import { fields } from ".";
import { Field, FieldArray, change, reduxForm } from "redux-form";
import Button from "components/atoms/Button";
import ReduxFormFields from "components/molecules/ReduxFormFields";
import InputRedux from "components/molecules/InputRedux";
import { lessThan100, number } from "utils/validate.util";
import { Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import BlockComponent from "components/organisms/BlockComponent/BlockComponent";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import BookingDetails from "./BookingDetails";
import NewPricingService from "services/newPricing.service";
import { useEffect } from "react";
import ClassService from "services/class.service";
let placeHolder: any = {
  English: {
    title: "Ladies and Gentlemen,",
    message:
      "Thank you for considering our limousine services. Below are the details of the service included in your quotation:",
    message2: `Included in the Price:

1. All rates are inclusive of VAT.
2. A complimentary water bottle will be provided for each trip.
3. Free waiting time of 15 minutes for city transfers.
4. Free waiting time of 60 minutes for airport pickups.

Terms and Conditions:
1. Cancellations are allowed at no charge up to 2 hours before the scheduled pickup time.
2. Cancellations made within 2 hours of pickup will incur a full charge.
3. Customers who do not show up for their scheduled pickup will be charged in full.
4. You can make free updates to your booking up to 4 hours before your scheduled pickup.

Should you require any further assistance or have additional inquiries, please feel free to contact us at your earliest convenience.

Best Regards,
`,
  },
  Arabic: {
    title: "السيدات والسادة،",
    message:
      "شكرًا على استفساركم! يسعدني أن أقدم لكم العرض التالي",
    message2: `يشمل السعر:

    1. وقت انتظار مجاني لمدة 60 دقيقة للاستقبال من المطار
    2. وقت انتظار مجاني لمدة 15 دقيقة للاستقبال من داخل المدينة
    3. إلغاء مجاني حتى ساعتين قبل موعد الرحلة

يرجى تفهم أنه قد تمر عدة أيام بين عرضنا وردكم، وقد لا تكون السعة متوفرة بعد ذلك. نرجو منكم التواصل معنا في هذه الحالة.

إذا كان لديكم أي أسئلة، يمكنكم التواصل معنا في أي وقت.`,
  },
};

function AddQuotationForm({ handleSubmit }: any) {
  let form = 'AddQuotationForm';
  let zoneID = '64fb1c3537a2a1b4fa9b907c'
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const Quotation = useAppSelector((state) => state.quotation.quotation);
  const bookings: any = useAppSelector((state) => state.form?.[form]?.values?.bookings);
  const discount: any = useAppSelector((state) => state.form?.[form]?.values?.discount);
  // const language = useAppSelector((state) => state.form?.[form]?.values?.language);


  let lang = "English"
  // let lang = language ? "English" : "Arabic";

  useEffect(() => {
    if (lang != Quotation?.language) {
      dispatch(change(form, "title", placeHolder[lang].title));
      dispatch(change(form, "message", placeHolder[lang].message));
      dispatch(change(form, "message2", placeHolder[lang].message2));
    } else {
      dispatch(change(form, "title", Quotation?.title));
      dispatch(change(form, "message", Quotation?.message));
      dispatch(change(form, "message2", Quotation?.message2));
    }
  }, [lang, id, dispatch, Quotation]);
  useEffect(() => {
    NewPricingService.getAllNewPricings(`?id=${zoneID}`);
    ClassService.getAllClasses();
  }, []);


  let total_price =
    bookings?.reduce((acc: any, booking: any) => acc + Number(booking.gross_price || 0), 0) || 0;

  useEffect(() => {
    if (discount)
      total_price = total_price - (Number(discount) / 100) * total_price;
    dispatch(change(form, "total_price", total_price?.toFixed(2)));

  }, [total_price, discount]);

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <ReduxFormFields fields={fields} />
        <FieldArray name="bookings" component={BookingDetails} />
        <Grid container spacing={2}>
          <Grid item md={8}></Grid>
          <Grid item md={4}>
            <Field
              name={"discount"}
              label={"Discount"}
              validate={[number, lessThan100]}
              component={InputRedux}
              InputProps={{ InputProps: { endAdornment: `%` } }}
            />
          </Grid>
          <Grid item md={8}></Grid>
          <Grid item md={4}>
            <Field
              name={"total_price"}
              label={"Total"}
              component={InputRedux}
              InputProps={{
                InputProps: { endAdornment: `EUR` },
                disabled: true,
              }}
            />
          </Grid>
          <Grid item md={12}>
            <Field
              name={"message2"}
              label={"Message"}
              component={InputRedux}
              InputProps={{
                multiline: true,
              }}
            />
          </Grid>
        </Grid>
        <br />
        <BlockComponent permission={"quotation:edit"}>
          <Button variant="contained" type="submit">
            Submit
          </Button>
        </BlockComponent>
      </form>
    </div>
  );
}
export default reduxForm({ form: "AddQuotationForm" })(AddQuotationForm);
